/*
  File name: crudFormComponents.js
    Program Description:
    - This file allows the components imported to be accessed globally.
*/
import Vue from 'vue'
import DateComponent from '../components/DateComponent'
import CrudTable from '../components/CrudTable'
import DataBreachForm from '../components/DataBreachForm'
import NoDataYet from '../components/NoDataYet'
import SecurityIncidentForm from '../components/SecurityIncidentForm'
import SecurityIncidentTable from '../components/SecurityIncidentTable'
import CrudTableExpand from '../components/CrudTableExpand'
import RadioButton from '../components/RadioButton'
import LookUpSelect from '../components/LookUpSelect'
import FileInputUpload from '../components/FileInputUpload'
import TimePicker from '../components/TimePicker'
import LabelError from '../components/LabelError'
import DynamicFileInput from '../components/DynamicFileInput'
import { VTextField, VRow, VCol, VCombobox, VCheckbox, VAutocomplete, VTextarea, VSelect, VCardSubtitle } from 'vuetify/lib'

Vue.component('DateComponent', DateComponent)
Vue.component('CrudTable', CrudTable)
Vue.component('DataBreachForm', DataBreachForm)
Vue.component('SecurityIncidentForm', SecurityIncidentForm)
Vue.component('SecurityIncidentTable', SecurityIncidentTable)
Vue.component('CrudTableExpand', CrudTableExpand)
Vue.component('VRow', VRow)
Vue.component('VCardSubtitle', VCardSubtitle)
Vue.component('VCol', VCol)
Vue.component('VCombobox', VCombobox)
Vue.component('VCheckbox', VCheckbox)
Vue.component('VAutocomplete', VAutocomplete)
Vue.component('VTextarea', VTextarea)
Vue.component('VSelect', VSelect)
Vue.component('VTextField', VTextField)
Vue.component('RadioButton', RadioButton)
Vue.component('LookUpSelect', LookUpSelect)
Vue.component('FileInputUpload', FileInputUpload)
Vue.component('NoDataYet', NoDataYet)
Vue.component('TimePicker', TimePicker)
Vue.component('LabelError', LabelError)
Vue.component('DynamicFileInput', DynamicFileInput)
